var check = true;
(function ()
{
  $(document).ready(function ()
  {
    $("body").addClass("rewards-page");
    if(check){
      initialize_swell();
      check = false;
    }

    $('body').on('click', '.swell-share-referral-copy', function(e) {
      setTimeout(function(){
        $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html().replace("http://",""));
      },20);
    });
    $('body').on('click', '.swell-referral-back-link.checkout', function(e) {
      $(".althea-rewards").css("display","none");
    });
    $('body').on('click', '.swell-referral-copy', function(e) {
      if ($(e.target).hasClass("swell-referral-copy")) {
        e.stopPropagation();
      }
    });

    $(document).on("swell:referral:success", function ()
    {
      swellAPI.refreshCustomerDetails(function ()
      {
        $(".table-data").html("");
        SwellConfig.Referral.populateReferrals();
      });
    });
    $(document).on("swell:referral:error", function (jqXHR, textStatus, errorThrown)
    {
      if (textStatus && textStatus === "EMAILS_ALREADY_PURCHASED")
      {
        $(".refer-customer-error").remove();
        $(".swell-referral-form-list").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
      }

      if (textStatus && textStatus === "Please enter a valid email address")
      {
        $(".refer-customer-error").remove();
        $(".swell-referral-form-list").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
      }
    });

    $('body').on('click', '.swell-post-checkout .post-checkout-close', function(e) {
      $(".swell-post-checkout").css("display","none");
    });
  });
  if(window.location.href.indexOf("orders")>0){
    initialize_swell();
    check = false;
  }
}).call(this);

function initialize_swell(){
  $(document).on("swell:setup", function () {
    if($(".swell-campaign-list").length>0){
      Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
      SwellConfig.Campaign.customCampaigns();
      SwellConfig.Campaign.loggedInCampaign();
      SwellConfig.Campaign.removeBirthdayCampaigns();
    }
    if($(".swell-referral").length>0){
      SwellConfig.Referral.initializeReferral(".swell-referral");
      SwellConfig.Referral.populateReferrals();
    }
    if($(".vip-tiers-types").length>0){
      SwellConfig.Tier.initializeDummyTier();
      SwellConfig.Tier.initializeCustomTierProperties();
      SwellConfig.Tier.initializeTiers(".vip-tiers-types");
      SwellConfig.Tier.initializeSlick();
    }
    $(".swell-loader-holder").hide();
    $(".althea-rewards").css("display","flex");
  });
}

//refer
(function ()
{
  window.SwellConfig = window.SwellConfig ||
  {};

  SwellConfig.Referral = {
    opts:
    {
      localization:
      {
        referralRegisterHeading: "Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
        referralRegisterFormDetails: "Enter your email to get started",
        referralReferHeading: "Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
        referralThanksHeading: "Thanks for Referring.",
        referralReferMediaDetails: "You can also share your link with the buttons below.",
        referralReferFormDetails: "Now, enter your friends' emails below.",
        referralReferFormEmailsDetails: "",
        referralRegisterFormEmail: "Enter your email to get started.",
        referralReferFormEmails: "Your friends’ emails (separated by commas)",
        referralRegisterFormEmail: "Enter your email",
        referralCopyButton: "COPY LINK",
        referralCopyDetails: "Copy link and share with your friends.",
        referralRegisterFormSubmit: "NEXT",
        referralReferFormSubmit: "SEND"
      },
      templates: {
        referralRegister: '<div class="swell-referral-register"><span class="swell-referral-heading-refer">Refer a Friend</span><h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"><%= localization.referralRegisterDetails %></p> <div class="swell-border"></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-body"> <p class="swell-referral-form-text"><%= localization.referralRegisterFormDetails %></p> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" swellrequired="swellrequired" placeholder="<%= localization.referralRegisterFormEmail %>"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"><span class="swell-referral-heading-refer">Refer a Friend</span><h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"><%= localization.referralReferDetails %></p> <div class="swell-border"></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-body"> <p class="swell-referral-form-text"><%= localization.referralReferFormDetails %></p> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" swellrequired="swellrequired" placeholder="<%= localization.referralReferFormEmails %>"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-facebook" aria-hidden="true"></i>Share </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-message-1" aria-hidden="true"></i>Message </div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-tweet" aria-hidden="true"></i> Tweet</div> </li> <li class="swell-referral-medium swell-mobile swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-sms-3" aria-hidden="true"></i>SMS </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-copy-link" aria-hidden="true"></i>Copy Link </div> </li> </ul> </div> </div>',
        referralCopy: '<div class="swell-referral-copy"> <div class="swell-referral-copy-content"> <div class="swell-referral-copy-sidebar"></div> <div class="swell-referral-copy-main"> <span class="swell-referral-back-link"></span> <div class="swell-referral-form-wrapper"> <div class="swell-referral-copy-link" id="swell-referral-copy-link"><%= customer.referralLink %></div> <button class="swell-referral-copy-button" id="swell-referral-copy-button" data-clipboard-target="#swell-referral-copy-link"> <%= localization.referralCopyButton %> </button> <p class="swell-referral-details"><%= localization.referralCopyDetails %></p> </div> </div></div> </div>'
      }
    },
    initializeReferral: function (containerSelector)
    {
      var email = $(containerSelector).data("customer-email");
      if (email)
      {
        spapi.storage.setItem("referrer_email", email);
        spapi.customer.email = email;
      }
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
    },
    populateReferrals: function ()
    {
      if (spapi.authenticated)
      {
        var referral_receipts = spapi.customer.referral_receipts;
        referral_receipts.forEach(function (referral_receipt)
        {
          var email = referral_receipt.email;
          var completed_at = referral_receipt.completed_at;
          if (completed_at)
          {
            status = "Purchased (" + spapi.activeReferralCampaign.reward_text + "earned)";
          }
          else
          {
            status = "Invited";
          }
          $(".table-data").append("<tr class='swell-table-row'><td class='swell-td swell-truncate'>" + email + "</td><td class='swell-td'>" + status + "</td></tr>");
        });
      }
    }
  };
}).call(this);

//campaigns
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: "<li class='swell-campaign'><div class='swell-campaign-content' data-display-mode='modal' data-campaign-id='<%= campaign.id %>'><div class='swell-campaign-icon'><span class='swell-campaign-icon-content'><i class='swell-icon <%= campaign.icon %>'><span class='path1'></span> <span class='path2'></span> <span class='path3'></span> </i></span></div><div class='swell-campaign-value'><span class='swell-campaign-value-content'><%= campaign.reward_text %></span></div><div class='swell-campaign-type'><span class='swell-campaign-type-content'><%= campaign.title %></span></div></div></li>"
      }
    },
    customCampaigns: function()
    {
      $(".swell-campaign-list").append('<li class="swell-campaign swell-campaign-refer"> <div class="swell-campaign-refer-left"> <h2 class="swell-heading"> Refer Friends </h2> <p class="swell-text"> Refer a Friend and get <span class="swell-text-pink">₱250</span> </p> </div> <div class="swell-campaign-refer-right"> <a class="swell-refer-btn" href="/pages/refer">START REFERRING NOW</a> </div> </li>')
    },
    loggedInCampaign: function() {
      if(spapi.authenticated) {
        $(".swell-campaign").css("cursor", "pointer");
      }
    },
    removeBirthdayCampaigns() {
      $(".swell-campaign .swell-campaign-content[data-campaign-id='489483']").parent().remove();
      $(".swell-campaign .swell-campaign-content[data-campaign-id='489484']").parent().remove();
    }
  };
}).call(this);

//tiers
(function () {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    getCustomerTierId: function () {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function (e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return -1;
        }
      }
    },
    getCustomerTierRank: function () {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function (e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function (e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function (rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function (e) {
        return e.rank === rank;
      })[0];
    },
    setupCustomerTierStatus: function () {
      var columnLength, customer_tier_id, customer_tier_rank, data_id, next_tier, spend_required, current = 2;
      customer_tier_id = SwellConfig.Tier.getCustomerTierId();
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);

      columnLength = $(".vip-tiers-types .slick-track").children().length;
      if (customer_tier_id == spapi.activeVipTiers[spapi.activeVipTiers.length - 1].id) {
        $(".vip-tiers-types .slick-track .slick-slide:nth-child(" + columnLength + ") .vip-tier-type").addClass("swell-current-status");
        $(".swell-campaign .swell-campaign-content[data-campaign-id='489055']").parent().remove();
        $(".swell-campaign .swell-campaign-content[data-campaign-id='489483']").parent().remove();
      } else {
        for(counter = 1; counter <= columnLength; counter++) {
          data_id = $(".vip-tiers-types .slick-track .slick-slide:nth-child(" + counter + ") .vip-tier-type").data("tier-id");
          if (data_id == customer_tier_id) {
            $(".vip-tiers-types .slick-track .slick-slide:nth-child(" + counter + ") .vip-tier-type").addClass("swell-current-status");
          }
          if(counter == 1) {
            $(".swell-campaign .swell-campaign-content[data-campaign-id='489483']").parent().remove();
            $(".swell-campaign .swell-campaign-content[data-campaign-id='489484']").parent().remove();
          } else if(counter == 2) {
            $(".swell-campaign .swell-campaign-content[data-campaign-id='489483']").parent().remove();
            $(".swell-campaign .swell-campaign-content[data-campaign-id='489055']").parent().remove();
          }
        }
      }
    },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        name: "Seed",
        icon: "<img src='//cdn.shopify.com/s/files/1/0100/3651/0782/t/16/assets/swell-vip-1.svg?v=153049845598824214351620407766'>",
        points: "Qualifying Amount ₱0" + "-₱" + (spapi.activeVipTiers[0].amount_spent_cents / 100).toLocaleString(),
        one_point_multiplier: "1x",
        birthday_rewards: "<li>Birthday Reward 50 points</li>",
        free_shipping: "",
        free_sample: "",
        swellrequiredAmountSpentCents: 0,
        swellrequiredPointsEarned: 0,
        swellrequiredPurchasesMade: 0,
        swellrequiredReferralsCompleted: 0
      });
    },
    initializeCustomTierProperties: function() {
      spapi.activeVipTiers[1].icon = "<img src='//cdn.shopify.com/s/files/1/0100/3651/0782/t/16/assets/swell-vip-2.svg?v=19737199374170556941620407766'>";
      spapi.activeVipTiers[1].points = "Qualifying Amount ₱" + ((spapi.activeVipTiers[1].amount_spent_cents / 100)+1).toLocaleString() + "-₱" + (spapi.activeVipTiers[2].amount_spent_cents / 100).toLocaleString();
      spapi.activeVipTiers[1].one_point_multiplier = spapi.activeVipTiers[1].points_multiplier+"x";
      spapi.activeVipTiers[1].birthday_rewards = "<li>Birthday Reward 62 points</li>";
      spapi.activeVipTiers[1].free_sample = "<li>1 FREE SHIPPING COUPON</li>";
      spapi.activeVipTiers[1].free_shipping = "";

      spapi.activeVipTiers[2].icon = "<img src='//cdn.shopify.com/s/files/1/0100/3651/0782/t/16/assets/swell-vip-3.svg?v=67029489113038041011620407767'>";
      spapi.activeVipTiers[2].points = "Qualifying Amount ₱" + (spapi.activeVipTiers[2].amount_spent_cents / 100).toLocaleString() + "+";
      spapi.activeVipTiers[2].one_point_multiplier = spapi.activeVipTiers[2].points_multiplier+"x";
      spapi.activeVipTiers[2].birthday_rewards = "<li>Birthday Reward 75 points</li>";
      spapi.activeVipTiers[2].free_sample = "<li>1 FREE SHIPPING COUPON</li>";
      spapi.activeVipTiers[2].free_shipping = "";
    },
    initializeTiers: function (containerSelector) {
      var tiers;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      tiers.forEach(function (tier) {
        $(containerSelector).append('<div data-tier-id="' + tier.id + '" class="vip-tier-type"> <div class="tier-content"> <div class="swell-icon">'+ tier.icon +'</div> <h4>' + tier.name + '</h4> <p>' + tier.points + '</p> <div class="swell-border"></div> <div class="point-multipler"> <h2>' + tier.one_point_multiplier + '</h2> <p>Point Multiplier</p> </div> <ul class="benefits">' + tier.birthday_rewards + ' ' + tier.free_sample + ' ' + tier.free_shipping + ' </ul> </div> </div>');
      });
    },
    initializeSlick: function() {
      $('.vip-tiers-types').slick({
        slidesToShow: 3,
        arrows: false,
        responsive: [
         {
          breakpoint: 769,
          settings: {
            infinite: true,
            centerMode: true,
            centerPadding: "13vw",
            arrows: true,
            arrows: false,
            slidesToScroll: 1,
            slidesToShow: 1
          }
        }]
      });
      if (spapi.authenticated) {
        return SwellConfig.Tier.setupCustomerTierStatus();
      }
    }
  };
}).call(this);

function check_window()
{
  if($(window).width() < 767 )
  {    
    $(".td2").css("display","table-cell"); 
    $(".td3").css("display","none"); 
    $(".td4").css("display","none");
  }
  else
  {
    $(".td2").css("display","table-cell");
    $(".td3").css("display","table-cell");
    $(".td4").css("display","table-cell");
  }
}
